<template>
  <ul class="dot-list">
    <li v-for="test in relatedTests" :key="test.title"><router-link :to="test.path">{{ test.title }}</router-link></li>
  </ul>
</template>
<script>
const tests = [
  ["Comprehensive Diabetes and Obesity Panel", "/test/Comprehensive Diabetes and Obesity"],
  ["Familial Hyperparathyroidism or Hypocalciuric Hypercalcemia Panel", "/test/Familial Hyperparathyroidism or Hypocalciuric Hypercalcemia Panel"],
  ["Hyperinsulinism Panel", "/test/Hyperinsulinism Panel"],
  ["Hypoglycemia Panel", "/test/Hypoglycemia Panel"],
  ["Inherited Obesity Panel", "/test/Inherited Obesity"],
  ["Maturity-Onset Diabetes of the Young (MODY) Panel", "/test/Maturity-Onset Diabetes of the Young"],
  ["Neonatal Diabetes Mellitus Panel", "/test/Neonatal Diabetes Mellitus"]
];

const relatedTestsByPanel = {
  "Maturity-Onset Diabetes of the Young (MODY) Panel": [
    ["Comprehensive Diabetes and Obesity Panel", "/test/Comprehensive Diabetes and Obesity"],
    ["Familial Hyperparathyroidism or Hypocalciuric Hypercalcemia Panel", "/test/Familial Hyperparathyroidism or Hypocalciuric Hypercalcemia Panel"],
    ["Hyperinsulinism Panel", "/test/Hyperinsulinism Panel"],
    ["Hypoglycemia Panel", "/test/Hypoglycemia Panel"],
    ["Inherited Obesity Panel", "/test/Inherited Obesity"],
    ["Neonatal Diabetes Mellitus Panel", "/test/Neonatal Diabetes Mellitus"]
  ],
  "Neonatal Diabetes Mellitus Panel": [
    ["Comprehensive Diabetes and Obesity Panel", "/test/Comprehensive Diabetes and Obesity"],
    ["Familial Hyperparathyroidism or Hypocalciuric Hypercalcemia Panel", "/test/Familial Hyperparathyroidism or Hypocalciuric Hypercalcemia Panel"],
    ["Hyperinsulinism Panel", "/test/Hyperinsulinism Panel"],
    ["Hypoglycemia Panel", "/test/Hypoglycemia Panel"],
    ["Inherited Obesity Panel", "/test/Inherited Obesity"],
    ["Maturity-Onset Diabetes of the Young Panel", "/test/Maturity-Onset Diabetes of the Young"]
  ]
};

export default {
  name: "EndocrinologyRelatedTests",
  props: { current: { type: String, required: true } },
  computed: {
    relatedTests() {
      const panelTests = relatedTestsByPanel[this.current];
      if (panelTests) {
        return panelTests.map(([title, path]) => ({ title, path }));
      }

      return tests
        .filter(([title]) => title !== this.current)
        .slice()
        .sort(([titleA], [titleB]) => titleA.localeCompare(titleB, "en"))
        .map(([title, path]) => ({ title, path }));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/test/Endocrinology/EndocrinologyRelatedTests.vue